import PatientDetails from './PatientDetails';

export default PatientDetails;
